import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $links: this.el._$$('a'),
      $viewBrochureLink: this.el._$('.view-brochure-link')
    };
  }

  addListeners() {
    if (this.dom.$viewBrochureLink !== null) {
      this.dom.$viewBrochureLink._on('click', this.scrollToSection.bind(this));
    }
    this.dom.$links.forEach((el, i) => el._on('click', this.downloadPDF.bind(this)));
  }

  scrollToSection(e) {
    e.preventDefault();
    const target = e.currentTarget.getAttribute('href');
    const targetEl = document.querySelector(target);
    const targetElOffset = targetEl.offsetTop;
    const headerHeight = document.querySelector('.header').offsetHeight;
    const targetPosition = targetElOffset - headerHeight;
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }

  downloadPDF(e) {
    e.preventDefault();
    if (e.currentTarget !== this.dom.$viewBrochureLink) {
      const url = e.currentTarget.href;
      fetch(url, {})
        .then(r => {
          return r.blob();
        })
        .then(this.savePDF.bind(null, url))
    }
  }

  savePDF(url, blobdata) {
    const a = document.createElement('a');
    const pdfname = url.split('/').pop();
    document.body.appendChild(a);
    a.style = 'display: none';
    const blob = new File([blobdata], pdfname, { type: 'octet/stream' });
    const linkurl = window.URL.createObjectURL(blob);
    a.href = linkurl;
    a.download = pdfname;
    a.target = '_blank';
    a.click();
    window.URL.revokeObjectURL(linkurl);
  }

  constructor(el) {
    super(el);
  }
}

export default Module;
